mainApp.service('GeneralPropertiesService', ['GeneralUtilsService', function(GeneralUtilsService){
	var generalPropertiesFactory = {};

    generalPropertiesFactory.parsedAndAddTempIdForGeneralPropertiesList = function(properties){
        if (properties){
            properties.forEach(function (item) {
                if(item.id == null){
                    item.id = GeneralUtilsService.getRandomId();
                }

                if (item.fieldType == "NUMBER"){
                    item.value = (item.value) ? parseInt(item.value, 10) : undefined;
                    item.parentValue = (item.parentValue) ? parseInt(item.parentValue, 10) : undefined;
                }
                if (item.fieldType == "BOOLEAN"){
                    item.value = (item.value) ? (item.value.toString().toLowerCase() == "true" ? true : false) : undefined;
                    item.parentValue = (item.parentValue) ? (item.parentValue.toString().toLowerCase() == "true" ? true : false) : undefined;
                }
                if (!item.fieldType){
                    item.fieldType = "STRING";
                }
            });
        }
    };

	return generalPropertiesFactory;
}]);